import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"
import G from "../../utils/SvgGroup"

const SquareIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-6.6 0 27 13"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <Path d="m0 0h14v14h-14z" />
      </clipPath>
      <G clip-path="url(#a)">
        <Path
          fill={color}
          d="m11.6603.00000009h-9.3206c-.62053 0-1.21564.24650291-1.654419.68528091-.438778.438779-.685281 1.033889-.685281 1.654419v9.3206c0 .6205.246503 1.2156.685281 1.6544.438779.4388 1.033889.6853 1.654419.6853h9.3206c.3073 0 .6115-.0604.8954-.178s.5418-.2899.7591-.5072.3896-.4752.5072-.7591.178-.5881.178-.8954v-9.3206c.0001-.30728-.0604-.61156-.1779-.89547-.1176-.2839-.2899-.541858-.5072-.759135-.2173-.217278-.4752-.389615-.7591-.507166-.2839-.1175515-.5882-.17801251-.8955-.17792891zm-.2055 10.71729991c-.0001.1957-.0779.3834-.2163.5217-.1384.1384-.3261.2161-.5218.2161h-7.43177c-.09693 0-.19292-.019-.28249-.0561-.08957-.037-.17096-.0914-.23953-.1599s-.12297-.1498-.16011-.2394c-.03713-.0895-.05626-.1855-.0563-.2824v-7.43205c-.00005-.09699.01903-.19303.05612-.28264.0371-.08961.09149-.17103.16006-.23961.06858-.06858.15-.12297.23961-.16006.08961-.0371.18565-.05617.28264-.05613h7.43137c.097 0 .193.01911.2826.05622s.1709.09151.2395.16009c.0685.06857.1229.14998.16.23957.037.08958.0561.1856.0561.28256v7.43205z"
        />
        <Path
          fill={color}
          d="m5.51753 8.90832c-.11267-.00034-.22061-.0454-.30007-.12529-.07947-.07988-.12396-.18805-.12371-.30072v-2.96646c0-.23511.18962-.42601.42378-.42601h2.97091c.2348 0 .42378.1909.42378.42601v2.96646c0 .2348-.18898.42601-.42378.42601z"
        />
      </G>
    </Svg>
  )
}

export default SquareIconSvg
